
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "26",
    "height": "27",
    "viewBox": "0 0 26 27"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "fill": "#000",
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "g",
                      "children": [
                        {
                          "tag": "path",
                          "attrsMap": {
                            "d": "M13 1.688C6.718 1.688 1.625 6.976 1.625 13.5c0 6.524 5.093 11.813 11.375 11.813s11.375-5.29 11.375-11.813c0-6.524-5.093-11.813-11.375-11.813zm0 21.937c-5.385 0-9.75-4.533-9.75-10.125S7.615 3.375 13 3.375s9.75 4.533 9.75 10.125S18.385 23.625 13 23.625zm7.643-12.84c0 .465-.364.843-.813.843-.38 0-.7-.271-.788-.638l-.006.003C18.078 8.506 15.736 6.75 13 6.75c-2.737 0-5.078 1.756-6.036 4.243l-.006-.003c-.089.367-.408.638-.788.638-.449 0-.813-.378-.813-.844 0-.145.037-.288.106-.415l-.008-.003C6.653 7.258 9.579 5.062 13 5.062c3.42 0 6.347 2.196 7.545 5.304l-.008.003c.07.127.106.27.106.415zm-3.193.391c-.387-.232-.887-.093-1.11.31l-3.01 5.412c-.11-.015-.22-.023-.33-.023-1.346 0-2.438 1.133-2.438 2.531 0 1.398 1.092 2.532 2.438 2.532s2.438-1.134 2.438-2.532c0-.67-.252-1.28-.662-1.733l2.971-5.344c.224-.402.09-.92-.297-1.153zM13 20.25c-.449 0-.813-.378-.813-.844 0-.466.364-.843.813-.843.449 0 .813.377.813.843 0 .466-.364.844-.813.844z",
                            "transform": "translate(-1103 -709) translate(355 692) translate(718) translate(30 17)"
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  